document.addEventListener('DOMContentLoaded', () => {
  const getItemCount = () => {
    const badgeEl = document.querySelector('.zrx-cart-toglle-badge');
    if (!badgeEl) return null;

    const count = parseInt(badgeEl.textContent.trim(), 10);
    return Number.isNaN(count) ? null : count;
  };

  const applyDiscount10 = () => {
    const count = getItemCount();
    if (count === null) return false;

    const discount10Selector = '.zrx-cart-discount.zrx-cart-discount--10';
    const discount15Selector = '.zrx-cart-discount.zrx-cart-discount--15';

    const existingDiscount10 = document.querySelector(discount10Selector);
    const existingDiscount15 = document.querySelector(discount15Selector);

    // Remove discount when count is 0 OR 3 or more
    if (count === 0 || count >= 3) {
      if (existingDiscount10) {
        existingDiscount10.remove();
        console.log(`Removed discount message because cart count is ${count}`);
      }
      if (existingDiscount15) {
        existingDiscount15.remove();
      }
      return true;
    }

    // Only show/insert for 1 or 2
    const cartItemsContainer = document.querySelector('.zrx-cart-items');
    if (!cartItemsContainer) return false;

    const productItems = cartItemsContainer.querySelectorAll(
      'div.zrx-cart-item[data-product-id]'
    );
    if (!productItems.length) return false;

    const lastProductItem = productItems[productItems.length - 1];

    // ✅ COUNT === 2: remove 10% and keep 15%
    if (count === 2) {
      if (existingDiscount10) {
        existingDiscount10.remove();
        console.log(`Removed discount message because cart count is ${count}`);
      }

      // Create if missing (15%)
      let discount15El = existingDiscount15;
      if (!discount15El) {
        discount15El = document.createElement('p');
        discount15El.className = 'zrx-cart-discount zrx-cart-discount--15';
        discount15El.textContent = 'Buy 3 save 15%';
      }

      // Place 15% after the last real product item
      if (lastProductItem.nextElementSibling !== discount15El) {
        lastProductItem.insertAdjacentElement('afterend', discount15El);
      }

      return true;
    }

    // ✅ COUNT === 1: show both 10% and 15%

    // Create if missing
    let discount10El = existingDiscount10;
    if (!discount10El) {
      discount10El = document.createElement('p');
      discount10El.className = 'zrx-cart-discount zrx-cart-discount--10';
      discount10El.textContent = 'Buy 2 save 10%';
    }

    let discount15El = existingDiscount15;
    if (!discount15El) {
      discount15El = document.createElement('p');
      discount15El.className = 'zrx-cart-discount zrx-cart-discount--15';
      discount15El.textContent = 'Buy 3 save 15%';
    }

    // Move to correct position if needed
    // - 10% goes after the last real product item
    // - 15% goes directly after the 10%
    if (lastProductItem.nextElementSibling !== discount10El) {
      lastProductItem.insertAdjacentElement('afterend', discount10El);
      console.log(`Inserted/moved discount message (count: ${count})`);
    }

    if (discount10El.nextElementSibling !== discount15El) {
      discount10El.insertAdjacentElement('afterend', discount15El);
    }

    return true;
  };

  const observer = new MutationObserver(() => {
    applyDiscount10();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Initial run
  applyDiscount10();
});
